export const PRIVILEGE_KEYS = {
  administration: 'administration.view',
  accessLogs: 'administration.access_logs.view',
  publicIllumination: {
    dashboardView: 'public_illumination.dashboard.view',
    dashboardExport: 'public_illumination.dashboard.export',
    mapView: 'public_illumination.map.view',
    mapFilter: 'public_illumination.map.filter',
    mapExport: 'public_illumination.map.export',
    serviceOrdersView: 'public_illumination.service_orders.view',
    serviceOrdersCreate: 'public_illumination.service_orders.create',
    serviceOrdersUpdate: 'public_illumination.service_orders.update',
    serviceOrdersClose: 'public_illumination.service_orders.close',
    serviceOrdersDelete: 'public_illumination.service_orders.delete',
    embeddedView: 'public_illumination.embedded_registration.view',
    cameraList: 'public_illumination.embedded_registration.camera_list',
    embeddedSync: 'public_illumination.embedded_registration.sync',
    pointsView: 'public_illumination.points.view',
    pointsCreate: 'public_illumination.points.create',
    pointsUpdate: 'public_illumination.points.update',
    pointsDelete: 'public_illumination.points.delete',
    reportsView: 'public_illumination.reports.view',
    reportsGenerate: 'public_illumination.reports.generate',
    reportsExport: 'public_illumination.reports.export',
  },
  consumerUnit: {
    mapView: 'consumer_unit.map.view',
    mapFilter: 'consumer_unit.map.filter',
    list: 'consumer_unit.units.list',
    view: 'consumer_unit.units.view',
    export: 'consumer_unit.units.export',
    create: 'consumer_unit.registration.create',
    update: 'consumer_unit.registration.update',
    delete: 'consumer_unit.registration.delete',
    importView: 'consumer_unit.account_import.view',
    importUpload: 'consumer_unit.account_import.upload',
    importValidate: 'consumer_unit.account_import.validate',
  },
} as const;

export type PrivilegeKey = string;

export const TEMPORARY_PRIVILEGE_KEYS: string[] = [
  ...Object.values(PRIVILEGE_KEYS.publicIllumination),
  ...Object.values(PRIVILEGE_KEYS.consumerUnit),
  PRIVILEGE_KEYS.administration,
  PRIVILEGE_KEYS.accessLogs,
];
